<app-navigation></app-navigation>
<div class="top-navi-container">
  <button class="top-navi" (click)="onNavigateBack()" mat-button><mat-icon>arrow_back</mat-icon>Abbrechen</button>
  <!-- <button
    class="top-navi align-right"
    #tooltip="matTooltip"
    (click)="tooltip.toggle()"
    [matTooltip]="anleitung"
    matTooltipPosition="before"
    mat-button>
    <mat-icon>info</mat-icon>Anleitung
  </button> -->
</div>

<mat-card class="card">
  <mat-card-content>
    @if (assessmentData(); as assessmentData) {
      @if (assessmentData) {
        <div class="grid">
          <app-dynamic-table-input-nhpt
            (inputData)="onNhptData($event)"
            [startTabIndex]="1"
            [note]="assessmentData.nhpt.note"
            [title]="assessmentData.nhpt.title"
            [manual]="assessmentData.nhpt.manual"
            [data]="assessmentData.nhpt.data"></app-dynamic-table-input-nhpt>
        </div>
      }
    }
    <form class="input-form" [formGroup]="form">
      <mat-form-field class="input">
        <mat-label>💬 Öffentlicher Kommentar zum Testergebnis (optional)</mat-label>
        <textarea tabIndex="20" type="text" matInput formControlName="note" placeholder=""></textarea>
      </mat-form-field>
      <mat-form-field class="input" id="dateErhebung">
        <mat-label>Zeitpunkt der Testung</mat-label>
        <input type="datetime-local" matInput formControlName="assessmentTime" placeholder="" />
      </mat-form-field>
      @if (hasError().nhpt) {
        <div class="error">
          <mat-error>Speichern nicht möglich, bitte zuerst die Eingabefehler korrigieren.</mat-error>
        </div>
      }
    </form>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="location.back()">Abbrechen</button>
      @if (assessmentId) {
        <button mat-flat-button color="secondary" (click)="onDelete(assessmentId)">Testung löschen</button>
      }
      <button mat-flat-button color="primary" (click)="onSave()" [disabled]="hasError().nhpt">Testung speichern</button>
    </div>
  </mat-card-content>
</mat-card>
